/* Copyright (C) 2011-2021 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
// 2. Store and Types. 
// 3. Scripts. 
import Credentials                                     from '../scripts/Credentials'     ;

// 10/16/2021 Paul.  Add support for user currency. 
export default class C10n
{
		public static ToCurrency(f: number): number
		{
			// 05/10/2006 Paul.  Short-circuit the math if USD. 
			// This is more to prevent bugs than to speed calculations. 
			if ( Credentials.bUSER_CurrencyUSDollars || Credentials.dUSER_CurrencyCONVERSION_RATE <= 0 )
				return f;
			return f * Credentials.dUSER_CurrencyCONVERSION_RATE;
		}

		public static FromCurrency(f: number): number
		{
			// 05/10/2006 Paul.  Short-circuit the math if USD. 
			// This is more to prevent bugs than to speed calculations. 
			if ( Credentials.bUSER_CurrencyUSDollars || Credentials.dUSER_CurrencyCONVERSION_RATE <= 0 )
				return f;
			return f / Credentials.dUSER_CurrencyCONVERSION_RATE;
		}
}

